module.exports = __webpack_public_path__ + "assets/img/my-spp-light.2033980c.png";